module.exports = __webpack_public_path__ + "static/media/userImage_3.3b9e64a6.png";